<template>

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="-11.5 780.5 24 24" >
<path d="M-1.41,797.92l1.92,1.91l1.9-1.91v-3.35l5.65-5.65l-0.35-0.36l-1.14,1.13l-1.16-1.16l1.13-1.14l-0.35-0.35l-1.14,1.14
	l-1.16-1.16l1.14-1.14l-0.35-0.35l-1.14,1.13l-1.16-1.16l1.14-1.14l-0.36-0.36l-1.14,1.14l-1.16-1.16l1.14-1.14l-0.36-0.36
	l-1.13,1.14l-1.13-1.13l-0.37,0.35l1.13,1.13l-1.16,1.16l-1.13-1.12l-0.35,0.35l1.13,1.13l-1.16,1.16l-1.13-1.13l-0.35,0.35
	l1.13,1.13l-1.16,1.16l-1.13-1.13l-0.35,0.35l1.13,1.13l-1.16,1.16l-1.13-1.13l-0.35,0.35l5.64,5.64L-1.41,797.92z M1.37,792.66
	c-0.49,0.47-1.27,0.45-1.74-0.04c-0.45-0.47-0.45-1.22,0-1.69l0.87-0.86l0.87,0.87C1.85,791.41,1.85,792.19,1.37,792.66z
	 M6.22,790.06l-1.16,1.16l-1.16-1.16l1.16-1.16L6.22,790.06z M4.7,788.54l-1.16,1.16l-1.16-1.16l1.16-1.16L4.7,788.54z M3.18,787.03
	l-1.16,1.16l-1.16-1.16l1.16-1.16L3.18,787.03z M0.5,784.34l1.16,1.16l-1.16,1.16l-1.16-1.16L0.5,784.34z M-1.02,785.86l1.16,1.16
	l-1.16,1.16l-1.16-1.16L-1.02,785.86z M-4.06,791.22l-1.16-1.16l1.16-1.16l1.16,1.16L-4.06,791.22z M-2.54,789.7l-1.16-1.16
	l1.16-1.16l1.16,1.16L-2.54,789.7z"/>
<path d="M7.88,791.87l1.45-1.45l-0.35-0.35l-5.14,5.14v3.25l-3.33,3.33l-3.33-3.33v-3.25l-5.14-5.14l-0.35,0.35l1.45,1.45
	l-1.63,1.62l5.18,5.18v2.31h2.31l1.52,1.52l1.52-1.52h2.31v-2.31l5.17-5.18L7.88,791.87z M-3.33,797.97l-4.48-4.48l1.28-1.27
	l3.2,3.2V797.97z M-2.83,800.49v-1.32l1.32,1.32H-2.83z M3.83,800.49H2.52l1.31-1.32V800.49z M4.33,795.42l3.2-3.21l1.27,1.28
	l-4.48,4.48L4.33,795.42z"/>
</svg>

</template>